const $ = (global.jQuery = require('jquery'));
require('bootstrap/js/tab');
const { numberFormat } = require('underscore');
const Marionette = require('backbone.marionette');
const Radio = require('backbone.radio');
const assign = require('lodash/assign');
const moment = require('moment');
const { BuildingListings } = require('app/public-app/apps/entities');
const Template = require('app/utils/template');
const Tooltips = require('app/common/behaviors/tooltips');
const Gallery = require('app/common/behaviors/gallery');
const {
    Currency: { decode: decodeCurrency },
} = require('app/utils/encoders');

const ListingsTpl = require('./templates/listings.html');
const ListingsLayoutTpl = require('./templates/listings-layout.html');
const ListingItemTpl = require('./templates/listing-item.html');

const channel = Radio.channel('global');

const ListingView = Marionette.ItemView.extend({
    tagName: 'tr',
    className: 'building-listing',
    template: Template(ListingItemTpl),

    behaviors: {
        Tooltips: {
            behaviorClass: Tooltips,
            container: 'body',
        },
        ListingPhotos: {
            behaviorClass: Gallery,
            gallerySelector: null,
            openGallerySelector: '[data-ui="listingPhotosGallery"]',
            galleryOptions: function () {
                return {
                    dynamic: true,
                    dynamicEl: this.getListingPhotos(),
                };
            },
        },
        ListingFloorplans: {
            behaviorClass: Gallery,
            gallerySelector: null,
            openGallerySelector: '[data-ui="listingFloorplansGallery"]',
            galleryOptions: function () {
                return {
                    dynamic: true,
                    dynamicEl: this.getListingFloorplans(),
                };
            },
        },
    },

    getListingPhotos() {
        return this.model.get('photos').map(item => {
            return { thumb: item.thumbnail, src: item.xlarge };
        });
    },

    getListingFloorplans() {
        return this.model.get('floorplans').map(item => {
            return { thumb: item.thumbnail, src: item.xlarge };
        });
    },

    templateHelpers() {
        return {
            decodeCurrency: decodeCurrency,
            isNewListing: moment(this.model.get('last_listed_at')).isAfter(moment().subtract(14, 'days')),
            getSquareFootage() {
                if (this.square_footage) {
                    return `${numberFormat(this.square_footage)} sqft`;
                }

                return ' - ';
            },
            getPrice() {
                const price = this.closed_price || this.price;
                return price ? `$${decodeCurrency(price)}` : '-';
            },
            getUnitNumber(defaultName) {
                return this.public_unit_number ? `#${this.public_unit_number}` : defaultName;
            },
            latestUpdate: this.model.latestUpdate(),
        };
    },
});

const ListingsView = Marionette.CompositeView.extend({
    childView: ListingView,
    template: Template(ListingsTpl),
    childViewContainer: 'tbody',

    LISTINGS_LIMIT: 25,
    showAll: false,

    ui: {
        showAllListings: '[data-ui="showAllListings"]',
    },

    events: {
        'click @ui.showAllListings': 'showAllListings',
    },

    showAllListings() {
        this.showAll = true;
        this.render();
    },

    filter(child, index) {
        if (!this.showAll) {
            return index < this.LISTINGS_LIMIT;
        }
        return true;
    },

    templateHelpers() {
        return {
            showLoadMore: !this.showAll && this.collection.length > this.LISTINGS_LIMIT,
        };
    },
});

const ListingsLayout = Marionette.LayoutView.extend({
    template: Template(ListingsLayoutTpl),

    regions: {
        rentals: '[data-region="rentals"]',
        sales: '[data-region="sales"]',
    },

    behaviors: {
        Tooltips: {
            behaviorClass: Tooltips,
        },
    },

    initialize() {
        this.pendingFetches = [];
        this.collections = {};

        const rentalsType = channel.request('constants:pick', 'listingType', { label: 'For Rent' });
        const salesType = channel.request('constants:pick', 'listingType', { label: 'For Sale' });

        this.PublicBuildingListings = BuildingListings.extend({
            url: `/p/building/${this.getOption('urlArgs').join('/')}/listings`,
        });

        this.registerListingsView(
            'rentals',
            { data: { listing_type: rentalsType } },
            { emptyText: 'No current listings for rent', isUnavailable: false }
        );

        this.registerListingsView(
            'sales',
            { data: { listing_type: salesType } },
            { emptyText: 'No current listings for sale', isUnavailable: false }
        );

        $.when.apply($, this.pendingFetches).then((...fetches) => {
            const hasListings = fetches.some(response => {
                const [items] = response;
                return items.length;
            });

            if (hasListings) {
                this.trigger('loaded');
            }
        });
    },

    onShow() {
        this.$('.nav-tabs li:not(.disabled):first a').tab('show');
    },

    registerListingsView(name, fetchData, viewOptions) {
        const collection = (this.collections[name] = new this.PublicBuildingListings([], {
            buildingId: this.model.get('building').id,
        }));
        const promise = collection.fetch(fetchData);
        const view = new ListingsView(assign({}, viewOptions, { collection: collection }));
        this.pendingFetches.push(promise);

        this.listenTo(this, 'show', function () {
            if (collection.length) {
                this.showChildView(name, view);
            }
        });
    },

    templateHelpers() {
        return this.collections;
    },
});

module.exports = {
    ListingsLayout,
};
